/* CTRL — Midnight Blue motion layer
   Smooth scroll, reveals, split text, scroll-linked effects, cursor glow, magnetic buttons. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Smooth scroll (Lenis) ---------- */
  var lenis = null;
  function initLenis() {
    if (reduce || design || typeof window.Lenis !== 'function') return;
    lenis = new window.Lenis({ duration: 1.15, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    window.ctrlLenis = lenis;
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    // Pause smooth scroll whenever Dawn locks the page (drawers, modals, search)
    var mo = new MutationObserver(function () {
      var locked = /overflow-hidden/.test(document.body.className);
      if (locked) lenis.stop(); else lenis.start();
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Anchor links glide
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      lenis.scrollTo(t, { offset: -80 });
    });
  }

  /* ---------- Split headings into words ---------- */
  function splitWords(el) {
    if (el.dataset.ctrlSplitDone) return;
    el.dataset.ctrlSplitDone = '1';
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'ctrl-w';
            var inner = document.createElement('span');
            inner.style.setProperty('--i', i++);
            inner.textContent = p;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    }
    walk(el);
    el.classList.add('ctrl-split');
  }

  /* ---------- Reveal on scroll ---------- */
  var io;
  function initReveals() {
    // Auto-upgrade common Dawn headings to split-word reveals
    var autoSplit = document.querySelectorAll(
      '[data-ctrl-split], .collection .title-wrapper-with-link .title, .newsletter__wrapper .h1, .rich-text__heading, .collection-list-title, .related-products__heading'
    );
    autoSplit.forEach(splitWords);

    var targets = document.querySelectorAll('[data-ctrl-reveal], .ctrl-split');
    if (reduce || design || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Scroll-highlight paragraphs ---------- */
  var highlights = [];
  function initHighlights() {
    highlights = highlights.filter(function (h) { return document.body.contains(h.el); });
    document.querySelectorAll('[data-ctrl-highlight]').forEach(function (el) {
      if (el.classList.contains('ctrl-highlight')) return;
      var accent = (el.dataset.accent || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var text = el.textContent.trim();
      el.textContent = '';
      var words = [];
      text.split(/\s+/).forEach(function (w, idx) {
        var s = document.createElement('span');
        s.className = 'ctrl-hw';
        var clean = w.toLowerCase().replace(/[^a-z0-9']/g, '');
        if (accent.indexOf(clean) > -1) s.classList.add('is-accent');
        s.textContent = w;
        el.appendChild(s);
        el.appendChild(document.createTextNode(' '));
        words.push(s);
      });
      el.classList.add('ctrl-highlight');
      highlights.push({ el: el, words: words });
    });
  }

  /* ---------- Scroll-linked effects ---------- */
  var progress, parallaxEls = [], velocityEls = [], heroEls = [];
  var lastY = window.scrollY, velocity = 0;

  function onScroll() {
    var y = window.scrollY;
    var vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;

    if (progress) progress.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
    doc.classList.toggle('ctrl-scrolled', y > 40);

    velocity += ((y - lastY) - velocity) * 0.2;
    lastY = y;

    if (reduce) return;

    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var speed = parseFloat(el.dataset.ctrlParallax) || 0.15;
      var center = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (center * -speed).toFixed(2) + 'px,0)';
    });

    heroEls.forEach(function (h) {
      var r = h.getBoundingClientRect();
      var p = Math.min(Math.max(-r.top / r.height, 0), 1);
      h.style.setProperty('--hero-p', p.toFixed(4));
    });

    highlights.forEach(function (h) {
      var r = h.el.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.3;
      var p = (start - r.top) / (start - end + r.height * 0.6);
      p = Math.min(Math.max(p, 0), 1);
      var lit = Math.round(p * h.words.length);
      for (var i = 0; i < h.words.length; i++) h.words[i].classList.toggle('is-lit', i < lit);
    });
  }

  function velocityLoop() {
    velocityEls.forEach(function (v) {
      var r = v.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var dir = parseFloat(v.el.dataset.direction || '1');
      v.x -= (0.6 + Math.min(Math.abs(velocity) * 0.15, 8)) * dir;
      var w = v.track.scrollWidth / 2;
      if (w > 0) {
        if (v.x <= -w) v.x += w;
        if (v.x > 0) v.x -= w;
      }
      v.track.style.transform = 'translate3d(' + v.x.toFixed(2) + 'px,0,0) skewX(' + Math.max(Math.min(-velocity * 0.15, 8), -8).toFixed(2) + 'deg)';
    });
    velocity *= 0.95;
    requestAnimationFrame(velocityLoop);
  }

  function initScrollFx() {
    progress = document.querySelector('.ctrl-progress');
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-ctrl-parallax]'));
    heroEls = Array.prototype.slice.call(document.querySelectorAll('[data-ctrl-hero]'));
    velocityEls = [];
    document.querySelectorAll('[data-ctrl-velocity]').forEach(function (el) {
      var track = el.querySelector('.ctrl-velo__track');
      if (track) velocityEls.push({ el: el, track: track, x: 0 });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    if (!reduce && velocityEls.length && !window.__ctrlVeloLoop) {
      window.__ctrlVeloLoop = true;
      requestAnimationFrame(velocityLoop);
    }
  }

  /* ---------- Cursor glow + magnetic + tilt ---------- */
  function initPointer() {
    if (!finePointer || reduce) return;
    var glow = document.querySelector('.ctrl-cursor');
    var mx = innerWidth / 2, my = innerHeight / 2, gx = mx, gy = my;
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      doc.classList.add('ctrl-has-cursor');
      document.querySelectorAll('[data-ctrl-mouse]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((mx - r.left) / r.width).toFixed(3));
        el.style.setProperty('--my', ((my - r.top) / r.height).toFixed(3));
      });
    }, { passive: true });
    document.addEventListener('mouseleave', function () { doc.classList.remove('ctrl-has-cursor'); });
    (function loop() {
      gx += (mx - gx) * 0.12; gy += (my - gy) * 0.12;
      if (glow) glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
      requestAnimationFrame(loop);
    })();

    // Magnetic buttons
    document.querySelectorAll('[data-ctrl-magnetic], .ctrl-hero .button, .ctrl-drop .button, .ctrl-story .button').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + x * 0.25 + 'px,' + y * 0.35 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });

    // 3D tilt
    document.querySelectorAll('[data-ctrl-tilt]').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + px * 8 + 'deg) rotateX(' + -py * 8 + 'deg)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Fit hero headline on one line ---------- */
  function fitHero() {
    document.querySelectorAll('.ctrl-hero__title').forEach(function (el) {
      var box = el.parentElement;
      var cs = getComputedStyle(box);
      var avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (avail <= 0) return;
      el.style.fontSize = '100px';
      el.style.width = 'max-content';
      var w = el.offsetWidth;
      el.style.width = '';
      if (!w) return;
      var size = Math.min(100 * (avail / w) * 0.995, 240);
      el.style.fontSize = size.toFixed(2) + 'px';
    });
  }
  var fitTimer;
  function scheduleFit() { clearTimeout(fitTimer); fitTimer = setTimeout(fitHero, 60); }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-ctrl-count]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        var el = en.target, to = parseFloat(el.dataset.ctrlCount) || 0, t0 = null;
        if (reduce) { el.textContent = to; return; }
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1600, 1);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 4)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { obs.observe(e); });
  }

  /* ---------- Auto-tag Dawn content for reveals ---------- */
  function autoTag() {
    if (document.querySelector('.scroll-trigger')) return; // Dawn handles its own when enabled
    document.querySelectorAll('.card-wrapper').forEach(function (c, i) {
      c.setAttribute('data-ctrl-reveal', '');
      c.style.setProperty('--d', (i % 4) * 90);
    });
  }

  ready(function () {
    fitHero();
    window.addEventListener('resize', scheduleFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHero);
    window.addEventListener('load', fitHero);
    autoTag();
    initLenis();
    initHighlights();
    initReveals();
    initScrollFx();
    initPointer();
    initCounters();
    fitHero();
    requestAnimationFrame(function () { doc.classList.add('ctrl-ready'); });
  });
  // Safety: never leave the intro covering the page
  setTimeout(function () { doc.classList.add('ctrl-ready'); }, 2500);

  // Re-init inside the theme editor when sections reload
  document.addEventListener('shopify:section:load', function () {
    fitHero();
    initHighlights();
    initReveals();
    initScrollFx();
  });
})();
